export default __webpack_public_path__ + "static/media/blueprint.8d708ea0.jpg";